import { sendEventToJumbo } from './jumbo';

export const USER_EVENTS = {
  GET_USER_DETAILS_SUCCESS: 'get_user_details_success',
  GET_USER_DETAILS_FAILURE: 'get_user_details_failure',
  USER_MEMBERSHIP_MODAL_OPEN: 'user_membership_modal_open',
  USER_FDP_MODAL_OPEN: 'user_fdp_modal_open',
  USER_DELIGHT_FEATURE_MODAL_OPEN: 'user_delight_feature_modal_open',
  USER_CONTEXT_MODAL_OPEN: 'user_context_modal_open',
  USER_MODAL_CLOSE: 'user_modal_close',
  UNMASK_USER_NUMBER_EVENT: 'unmask_user_number_event',
  UNMASK_USER_ALTERNATE_NUMBER_EVENT: 'unmask_user_alternate_number_event',
  UNMASK_USER_OFSE_NUMBER_EVENT: 'unmask_user_ofse_number_event',
  UNMASK_USER_EMAIL_EVENT: 'unmask_user_email_event',
  REGENERATE_USER_NUMBER_EVENT: 'regenerate_user_number_event',
  REGENERATE_USER_ALTERNATE_NUMBER_EVENT:
    'regenerate_user_alternate_number_event',
  REGENERATE_USER_OFSE_NUMBER_EVENT: 'regenerate_user_ofse_number_event',
};

export const sendUserApiEvents = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
    responseMeta: { isNewUser: !orderId && customerId ? 'true' : 'false' },
  });
};

export const sendUserModalEvent = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
    responseMeta: { isNewUser: !orderId && customerId ? 'true' : 'false' },
  });
};

export const sendUserUnmaskEvent = (eventName, orderId, customerId) => {
  sendEventToJumbo({
    eventName,
    orderId,
    customerId,
    responseMeta: { isNewUser: !orderId && customerId ? 'true' : 'false' },
  });
};
